import { REACT_APP_API_ABM_FW } from '../../config'
import axios from 'axios'

export async function getUserByConfirmId(confirmId) {
    const response =  axios.get(REACT_APP_API_ABM_FW + "/users/" + confirmId + "/getUserByConfirmId");
    return response
}